import { render } from "./ImageCollageShell.vue?vue&type=template&id=0ae036dd&scoped=true"
import script from "./ImageCollageShell.vue?vue&type=script&lang=js"
export * from "./ImageCollageShell.vue?vue&type=script&lang=js"

import "./ImageCollageShell.vue?vue&type=style&index=0&id=0ae036dd&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae036dd"]])

export default __exports__